<template>
  <div class="Wholepage exam-page" :style="examFontStyle">
    <el-container style="height: 100%">
      <el-header style="height: 90px">
        <span class="examInfoTitle exam-info-title">{{ systemName }} - {{ examData.Name }} <el-tag size="small" type="warning" effect="dark" style="margin-left: 8px; vertical-align: middle">模拟考试</el-tag></span>
        <span class="examInfoShow exam-info-show">试卷总分：{{ examData.TotalScore }} / 合格分数：{{
          examData.PassScore
        }}
          / 考试时间：{{ examData.AnswerTime }}分钟</span>
        <div class="exam-header__font-size">
          <span class="exam-header__font-size-label">字号</span>
          <div class="exam-font-size-group">
            <button type="button" class="exam-font-size-btn exam-font-size-btn--step" :disabled="!canDecreaseFontSize" @click="decreaseFontSize">−</button>
            <span class="exam-font-size-value">{{ fontScalePercent }}%</span>
            <button type="button" class="exam-font-size-btn exam-font-size-btn--step" :disabled="!canIncreaseFontSize" @click="increaseFontSize">+</button>
          </div>
        </div>
      </el-header>
      <el-container class="WholePannel exam-panel">
        <el-aside width="360px" class="sidebar-left">
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <template slot="title">
                <i class="header-icon el-icon-user-solid"></i>
                学员信息
              </template>
              <div class="sidebar-content">
                <el-avatar v-if="examData && examData.HeadImage" :size="120" :src="examData.HeadImage" fit="cover">
                  <img src="../assets/default-image.png" />
                </el-avatar>
                <div class="student-info-form">
                  <el-form :model="examData" label-width="80px" size="mini">
                    <el-form-item label="姓名">
                      <el-input v-model="examData.RealName" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="性别">
                      <el-input v-model="examData.Sex" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号">
                      <IdCardMasked :value="examData.IDCard" />
                    </el-form-item>
                    <el-form-item label="人员类别">
                      <el-input v-model="examData.MenTypeName" readonly></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <i class="header-icon el-icon-star-on"></i>
                考试信息
              </template>
              <div class="sidebar-content">
                <el-progress type="dashboard" :percentage="percentage" :color="colors"></el-progress>
              </div>
              <div class="exam-action-form">
                <el-form :model="lastTimeForm" label-width="80px" size="mini">
                  <el-form-item label="剩余时间">
                    <el-input v-model="lastTimeForm.lastTimeShow" readonly></el-input>
                  </el-form-item>
                  <el-form-item label-width="0" class="exam-btn-item">
                    <div class="exam-btn-group">
                      <el-button type="primary" @click="submitPage(false)" size="medium">提交试卷</el-button>
                      <el-button type="success" @click="isShowAnswer = !isShowAnswer" size="medium">{{ isShowAnswer ?
                        "关闭答案" : "查看答案"
                      }}</el-button>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-aside>
        <el-main id="el-main-pannel" :style="examFontStyle">
          <el-divider content-position="left">题目信息</el-divider>
          <div :id="'q' + (index + 1)" class="questionList question-list" v-if="examData &&
              examData.QuestionList &&
              examData.QuestionList.length > 0
              " v-for="(item, index) in examData.QuestionList">
            <div class="question-title">
              <div class="question-stem">
                <el-tag type="success" v-show="item.QuestionStyle == 1" style="margin-right: 6px">判断题</el-tag>
                <el-tag v-show="item.QuestionStyle == 2" style="margin-right: 6px">单选题</el-tag>
                <el-tag type="warning" v-show="item.QuestionStyle == 3" style="margin-right: 6px">多选题</el-tag>
                {{ index + 1 }}、<span v-html="formatCopyGuardHtml(item.QuestionContent)"></span>
              </div>
            </div>
            <div class="question-options">
              <el-radio-group v-show="item.QuestionStyle == 1" v-model="item.UserAnswer"
                @change="userAnswerQuestion(index)">
                <el-radio-button label="A" :class="getOptionClass(item, index, 'A')">正确</el-radio-button>
                <el-radio-button label="B" :class="getOptionClass(item, index, 'B')">错误</el-radio-button>
              </el-radio-group>
              <el-radio-group v-show="item.QuestionStyle == 2" v-model="item.UserAnswer"
                @change="userAnswerQuestion(index)">
                <el-radio-button label="A" :class="getOptionClass(item, index, 'A')">A、<span v-html="formatCopyGuardHtml(item.AnswerA)"></span></el-radio-button>
                <el-radio-button label="B" :class="getOptionClass(item, index, 'B')">B、<span v-html="formatCopyGuardHtml(item.AnswerB)"></span></el-radio-button>
                <el-radio-button v-show="item.AnswerC" label="C" :class="getOptionClass(item, index, 'C')">C、<span v-html="formatCopyGuardHtml(item.AnswerC)"></span></el-radio-button>
                <el-radio-button v-show="item.AnswerD" label="D" :class="getOptionClass(item, index, 'D')">D、<span v-html="formatCopyGuardHtml(item.AnswerD)"></span></el-radio-button>
                <el-radio-button v-show="item.AnswerE" label="E" :class="getOptionClass(item, index, 'E')">E、<span v-html="formatCopyGuardHtml(item.AnswerE)"></span></el-radio-button>
                <el-radio-button v-show="item.AnswerF" label="F" :class="getOptionClass(item, index, 'F')">F、<span v-html="formatCopyGuardHtml(item.AnswerF)"></span></el-radio-button>
                <el-radio-button v-show="item.AnswerG" label="G" :class="getOptionClass(item, index, 'G')">G、<span v-html="formatCopyGuardHtml(item.AnswerG)"></span></el-radio-button>
                <el-radio-button v-show="item.AnswerH" label="H" :class="getOptionClass(item, index, 'H')">H、<span v-html="formatCopyGuardHtml(item.AnswerH)"></span></el-radio-button>
              </el-radio-group>
              <el-checkbox-group v-show="item.QuestionStyle == 3" v-model="userAnswerArray"
                @change="userAnswerQuestion(index)">
                <el-checkbox-button :label="item.Id + '|A'" :class="getOptionClass(item, index, item.Id + '|A')">A、<span v-html="formatCopyGuardHtml(item.AnswerA)"></span></el-checkbox-button>
                <el-checkbox-button :label="item.Id + '|B'" :class="getOptionClass(item, index, item.Id + '|B')">B、<span v-html="formatCopyGuardHtml(item.AnswerB)"></span></el-checkbox-button>
                <el-checkbox-button v-show="item.AnswerC" :label="item.Id + '|C'" :class="getOptionClass(item, index, item.Id + '|C')">C、<span v-html="formatCopyGuardHtml(item.AnswerC)"></span></el-checkbox-button>
                <el-checkbox-button v-show="item.AnswerD" :label="item.Id + '|D'" :class="getOptionClass(item, index, item.Id + '|D')">D、<span v-html="formatCopyGuardHtml(item.AnswerD)"></span></el-checkbox-button>
                <el-checkbox-button v-show="item.AnswerE" :label="item.Id + '|E'" :class="getOptionClass(item, index, item.Id + '|E')">E、<span v-html="formatCopyGuardHtml(item.AnswerE)"></span></el-checkbox-button>
                <el-checkbox-button v-show="item.AnswerF" :label="item.Id + '|F'" :class="getOptionClass(item, index, item.Id + '|F')">F、<span v-html="formatCopyGuardHtml(item.AnswerF)"></span></el-checkbox-button>
                <el-checkbox-button v-show="item.AnswerG" :label="item.Id + '|G'" :class="getOptionClass(item, index, item.Id + '|G')">G、<span v-html="formatCopyGuardHtml(item.AnswerG)"></span></el-checkbox-button>
                <el-checkbox-button v-show="item.AnswerH" :label="item.Id + '|H'" :class="getOptionClass(item, index, item.Id + '|H')">H、<span v-html="formatCopyGuardHtml(item.AnswerH)"></span></el-checkbox-button>
              </el-checkbox-group>
            </div>
            <div
              v-if="isShowAnswer && getQuestionNavItem(index)"
              :class="[
                'answer-reveal',
                getQuestionNavItem(index).userAnswerState == 3 ? 'is-wrong' : '',
              ]"
            >
              <div class="answer-reveal-label">
                正确答案：{{ formatAnswerText(item, index) }}
              </div>
              <div class="answer-analysis">
                解析：{{ getQuestionNavItem(index).topicAnalysis || '暂无' }}
              </div>
            </div>
          </div>
        </el-main>
        <el-aside width="360px" class="nav-aside">
          <el-divider content-position="left">题目导航</el-divider>
          <el-breadcrumb v-show="questionStyleItemList1 && questionStyleItemList1.length > 0" separator="/">
            <el-breadcrumb-item>判断题</el-breadcrumb-item>
          </el-breadcrumb>
          <ul class="mt15" v-show="questionStyleItemList1 && questionStyleItemList1.length > 0">
            <li class="questionNavBtn question-nav-btn" v-for="item in questionStyleItemList1">
              <el-button
                :type="getNavBtnType(item)"
                size="small"
                round
                @click="goAnchor('#q' + item.questionIndex)"
              >{{ item.questionIndex }}</el-button>
            </li>
          </ul>
          <p v-show="questionStyleItemList2 && questionStyleItemList2.length > 0">&emsp;</p>
          <el-breadcrumb v-show="questionStyleItemList2 && questionStyleItemList2.length > 0" separator="/"
            class="mt15 clearFloat">
            <el-breadcrumb-item>单选题</el-breadcrumb-item>
          </el-breadcrumb>
          <ul class="mt15" v-show="questionStyleItemList2 && questionStyleItemList2.length > 0">
            <li class="questionNavBtn question-nav-btn" v-for="item in questionStyleItemList2">
              <el-button
                :type="getNavBtnType(item)"
                size="small"
                round
                @click="goAnchor('#q' + item.questionIndex)"
              >{{ item.questionIndex }}</el-button>
            </li>
          </ul>
          <p v-show="questionStyleItemList3 && questionStyleItemList3.length > 0">&emsp;</p>
          <el-breadcrumb v-show="questionStyleItemList3 && questionStyleItemList3.length > 0" separator="/"
            class="mt15 clearFloat">
            <el-breadcrumb-item>多选题</el-breadcrumb-item>
          </el-breadcrumb>
          <ul class="mt15" v-show="questionStyleItemList3 && questionStyleItemList3.length > 0">
            <li class="questionNavBtn question-nav-btn" v-for="item in questionStyleItemList3">
              <el-button
                :type="getNavBtnType(item)"
                size="small"
                round
                @click="goAnchor('#q' + item.questionIndex)"
              >{{ item.questionIndex }}</el-button>
            </li>
          </ul>
          <p>&emsp;</p>
        </el-aside>
      </el-container>
    </el-container>
    <el-dialog
      title="考核结果"
      :visible.sync="resultDialogShow"
      width="420px"
      custom-class="exam-result-dialog"
      :show-close="false"
      :close-on-click-modal="false"
      :before-close="handleDialogClose"
    >
      <div class="result-dialog-body">
        <div
          :class="[
            'result-icon-wrap',
            resultImgType === 'success.png' ? 'is-success' : 'is-fail',
          ]"
        >
          <img :src="require('../assets/' + resultImgType)" alt="考核结果" />
        </div>
        <h3
          :class="[
            'result-title',
            resultImgType === 'success.png' ? 'is-success' : 'is-fail',
          ]"
        >
          {{ resultStatusTitle }}
        </h3>
        <p class="result-content">{{ resultTipContent }}</p>
      </div>
      <span slot="footer" class="result-dialog-footer">
        <el-button type="primary" @click="handleDialogClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  submitPCExamineUserAnswer,
  submitPCExamine,
  getExamineTestAnswer,
} from "../api/index.js";
import IdCardMasked from "../components/IdCardMasked.vue";
import { buildCopyGuardHtml } from "../utils/copyGuard.js";
import {
  getExamFontScale,
  increaseExamFontScale,
  decreaseExamFontScale,
  canIncreaseExamFontScale,
  canDecreaseExamFontScale,
  formatExamFontScalePercent,
  getExamFontStyle,
} from "../utils/examFontSize.js";
export default {
  name: "Test",
  components: { IdCardMasked },
  data() {
    return {
      systemName: "山西传人科技企业培训综合管理平台",
      examData: {},
      activeNames: ["1", "2"], //左侧Collapse选项卡切换
      percentage: 0, //剩余时间仪表盘
      colors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#6f7ad3", percentage: 100 },
      ],
      lastTimeForm: {
        totalTime: 0,
        lastTime: 0,
        lastTimeShow: "00:00:00",
      }, //倒计时展示
      userAnswerArray: [], //多选题答案
      questionStyleItemList1: [], //判断题导航列表
      questionStyleItemList2: [], //单选题导航列表
      questionStyleItemList3: [], //多选题导航列表
      resultDialogShow: false,
      resultImgType: "wait.png",
      resultTipContent: "您还没有提交试卷",
      isUserSubmit: false, //用户是否交卷
      isShowAnswer: false, //是否显示正确答案
      testRightAnswer: [], //模拟练习正确答案
      fontScale: getExamFontScale(),
    };
  },
  computed: {
    examFontStyle() {
      return getExamFontStyle(this.fontScale);
    },
    fontScalePercent() {
      return formatExamFontScalePercent(this.fontScale);
    },
    canIncreaseFontSize() {
      return canIncreaseExamFontScale(this.fontScale);
    },
    canDecreaseFontSize() {
      return canDecreaseExamFontScale(this.fontScale);
    },
    resultStatusTitle() {
      if (this.resultImgType === "success.png") return "考核通过";
      if (this.resultImgType === "error.png") return "考核未通过";
      return "考核结果";
    },
  },
  methods: {
    formatCopyGuardHtml(text) {
      return buildCopyGuardHtml(text);
    },
    increaseFontSize() {
      this.fontScale = increaseExamFontScale(this.fontScale);
    },
    decreaseFontSize() {
      this.fontScale = decreaseExamFontScale(this.fontScale);
    },
    getQuestionNavItem(index) {
      const idx = index + 1;
      return (
        this.questionStyleItemList1.find((i) => i.questionIndex === idx) ||
        this.questionStyleItemList2.find((i) => i.questionIndex === idx) ||
        this.questionStyleItemList3.find((i) => i.questionIndex === idx)
      );
    },
    formatAnswerText(item, index) {
      const nav = this.getQuestionNavItem(index);
      if (!nav || !nav.answerStandard) return "-";
      if (item.QuestionStyle == 1) {
        return nav.answerStandard === "A" ? "正确" : "错误";
      }
      return nav.answerStandard.replace(/,/g, "、");
    },
    isStandardOption(standard, key) {
      if (!standard) return false;
      return standard.split(",").some((s) => s.trim() === key);
    },
    isUserSelectedOption(item, optKey) {
      if (item.QuestionStyle == 3) {
        return this.userAnswerArray.indexOf(optKey) > -1;
      }
      return item.UserAnswer === optKey;
    },
    getOptionClass(item, index, optKey) {
      if (!this.isShowAnswer) return "";
      const nav = this.getQuestionNavItem(index);
      if (!nav) return "";
      const answerKey = item.QuestionStyle == 3 ? optKey.split("|")[1] : optKey;
      const isCorrect = this.isStandardOption(nav.answerStandard, answerKey);
      const isSelected = this.isUserSelectedOption(item, optKey);
      if (isCorrect) return "option-correct";
      if (isSelected && !isCorrect) return "option-wrong";
      return "";
    },
    getNavBtnType(item) {
      if (item.userAnswerState == 1) return "info";
      if (!this.isShowAnswer) return "primary";
      if (item.userAnswerState == 2) return "success";
      return "danger";
    },
    //倒计时
    timeCount() {
      if (this.isUserSubmit == true) {
        return;
      }
      this.lastTimeForm.lastTime -= 1;
      if (this.lastTimeForm.lastTime > 0) {
        let temph = Math.floor((this.lastTimeForm.lastTime / 60 / 60) % 24);
        let tempm = Math.floor((this.lastTimeForm.lastTime / 60) % 60);
        let temps = Math.floor(this.lastTimeForm.lastTime % 60);
        setTimeout(this.timeCount, 1000);
        this.lastTimeForm.lastTimeShow =
          this.prefixZero(temph, 2) +
          ":" +
          this.prefixZero(tempm, 2) +
          ":" +
          this.prefixZero(temps, 2);
        //计算时间百分比
        this.percentage = Math.floor(
          (this.lastTimeForm.lastTime * 100) / this.lastTimeForm.totalTime
        );
      } else {
        //到时间自动交卷
        this.submitPage(true);
      }
    },
    //自动补零
    prefixZero(num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },
    //跳转到特定题目锚点（对齐上一题下边框）
    goAnchor(selector) {
      const anchor = document.querySelector(selector);
      const container = document.querySelector("#el-main-pannel");
      if (!anchor || !container) return;

      const questionIndex = parseInt(String(anchor.id).replace(/^q/, ""), 10);
      if (!questionIndex || questionIndex <= 1) {
        container.scrollTop = 0;
        return;
      }

      const prev = document.querySelector("#q" + (questionIndex - 1));
      if (!prev) {
        container.scrollTop = 0;
        return;
      }

      const containerTop = container.getBoundingClientRect().top;
      const prevBottom = prev.getBoundingClientRect().bottom;
      container.scrollTop += prevBottom - containerTop;
    },
    //点击答案事件
    userAnswerQuestion(questionIndex) {
      let tempQuestion = this.examData.QuestionList[questionIndex];
      //console.log(tempQuestion);
      //提交用户答案到服务器
      let tempParam = {
        Id: tempQuestion.Id,
        UserAnswer: tempQuestion.UserAnswer,
      };
      if (tempQuestion.QuestionStyle == 3) {
        tempParam.UserAnswer = "";
        if (this.userAnswerArray && this.userAnswerArray.length > 0) {
          this.userAnswerArray.forEach((item) => {
            if (item.split("|")[0] == tempQuestion.Id) {
              tempParam.UserAnswer += item.split("|")[1];
            }
          });
        }
      }
      this.justSubmitUserAnswer(tempParam);
      //赋值右侧导航按钮背景色
      let _this = this;
      if (tempQuestion.QuestionStyle == 1) {
        this.questionStyleItemList1.forEach((item) => {
          if (item.questionIndex == questionIndex + 1) {
            if (tempParam.UserAnswer == item.answerStandard) {
              item.userAnswerState = 2;
            } else {
              item.userAnswerState = 3;
            }
          }
        });
      } else if (tempQuestion.QuestionStyle == 2) {
        this.questionStyleItemList2.forEach((item) => {
          if (item.questionIndex == questionIndex + 1) {
            if (tempParam.UserAnswer == item.answerStandard) {
              item.userAnswerState = 2;
            } else {
              item.userAnswerState = 3;
            }
          }
        });
      } else {
        //判断多选题答案选择数量及对错
        let tempUserAnswer = "";
        if (this.userAnswerArray && this.userAnswerArray.length > 0) {
          this.userAnswerArray.forEach((item) => {
            if (item.split("|")[0] == tempQuestion.Id) {
              tempUserAnswer += item.split("|")[1] + ",";
            }
          });
        }
        //console.log(tempUserAnswer);
        this.questionStyleItemList3.forEach((item) => {
          if (item.questionIndex == questionIndex + 1) {
            if (tempUserAnswer) {
              if (tempUserAnswer.length == item.answerStandard.length + 1) {
                let isAnswerRight = true;
                let tempAnswerArray = item.answerStandard.split(",");
                tempAnswerArray.forEach((itemAnswerChar) => {
                  if (tempUserAnswer.indexOf(itemAnswerChar) == -1) {
                    isAnswerRight = false;
                  }
                });
                item.userAnswerState = isAnswerRight ? 2 : 3;
              } else {
                item.userAnswerState = 3;
              }
            } else {
              item.userAnswerState = 1;
            }
          }
        });
      }
    },
    //提交用户答案到服务器
    justSubmitUserAnswer(tempParam) {
      let _this = this;
      submitPCExamineUserAnswer(tempParam)
        .then((res) => {
          if (res.state == "success") {
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //提交试卷
    submitPage(isAuto) {
      if (isAuto == true) {
        this.justSubmitPage();
      } else {
        //判断试题是否已全部答完
        let pageAnswerIsComplete = true;
        this.questionStyleItemList1.forEach((item) => {
          if (item.userAnswerState == 1) {
            pageAnswerIsComplete = false;
          }
        });
        this.questionStyleItemList2.forEach((item) => {
          if (item.userAnswerState == 1) {
            pageAnswerIsComplete = false;
          }
        });
        this.questionStyleItemList3.forEach((item) => {
          if (item.userAnswerState == 1) {
            pageAnswerIsComplete = false;
          }
        });
        if (pageAnswerIsComplete == false) {
          this.$message.error("请完成全部题目再提交试卷");
          return false;
        }
        //判断考试时间长度，是否允许交卷【暂未完善】
        let _this = this;
        this.$confirm(
          "提交后将无法继续答题，请确认所有题目已作答完毕。",
          "提交试卷",
          {
            confirmButtonText: "确认提交",
            cancelButtonText: "再检查一下",
            type: "warning",
            customClass: "exam-message-box",
            center: false,
          }
        )
          .then((_) => {
            _this.justSubmitPage();
          })
          .catch((_) => { });
      }
    },
    justSubmitPage() {
      this.isUserSubmit = true;
      let _this = this;
      let tempParam = {
        examineInfoId: _this.examData.Id,
      };
      submitPCExamine(tempParam)
        .then((res) => {
          if (res.state == "success") {
            _this.resultDialogShow = true;
            _this.resultTipContent = res.data;
            if (res.data.indexOf("恭喜") > -1) {
              _this.resultImgType = "success.png";
            } else {
              _this.resultImgType = "error.png";
            }
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //关闭考核结果弹窗
    handleDialogClose() {
      this.resultDialogShow = false;
      this.resetForm();
      let jumpPage = sessionStorage.getItem("indexPage");
      this.$router.push("/" + jumpPage);
    },
    //重置表单信息
    resetForm() {
      this.examData = {};
      this.activeNames = ["1", "2"];
      this.percentage = 0;
      this.lastTimeForm = {
        totalTime: 0,
        lastTime: 0,
        lastTimeShow: "00:00:00",
      };
      this.userAnswerArray = [];
      this.questionStyleItemList1 = [];
      this.questionStyleItemList2 = [];
      this.questionStyleItemList3 = [];
      this.resultImgType = "wait.png";
      this.resultTipContent = "您还没有提交试卷";
      this.isUserSubmit = false;
      this.isShowAnswer = false;
      this.testRightAnswer = [];
    },
  },
  activated() {
    var systemName = sessionStorage.getItem("systemName");
    if (systemName) {
      this.systemName = systemName;
      document.title = systemName;
    }
    var cacheDataString = sessionStorage.getItem("examData");
    if (cacheDataString) {
      //防止刷新页面
      sessionStorage.removeItem("examData");
      this.examData = JSON.parse(cacheDataString);
      //console.log(this.examData);
      //加载试卷正确答案
      let _this = this;
      let tempParam = {
        examineInfoId: _this.examData.Id,
      };
      getExamineTestAnswer(tempParam)
        .then((res) => {
          if (res.state == "success") {
            _this.testRightAnswer = res.data;
            //赋值右侧题目导航
            let questionMenuList1 = [];
            let questionMenuList2 = [];
            let questionMenuList3 = [];
            _this.examData.QuestionList.forEach((item, index) => {
              let dataModel = {
                questionIndex: index + 1,
                userAnswerState: 1,
                answerStandard: "",
                topicAnalysis: "",
              };
              _this.testRightAnswer.forEach((itemRight) => {
                if (itemRight.Id == item.Id) {
                  dataModel.answerStandard = itemRight.AnswerStandard;
                  dataModel.topicAnalysis = itemRight.TopicAnalysis;
                }
              });
              if (item.QuestionStyle == 1) {
                questionMenuList1.push(dataModel);
              } else if (item.QuestionStyle == 2) {
                questionMenuList2.push(dataModel);
              } else {
                questionMenuList3.push(dataModel);
              }
            });
            this.questionStyleItemList1 = questionMenuList1;
            this.questionStyleItemList2 = questionMenuList2;
            this.questionStyleItemList3 = questionMenuList3;
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
      this.lastTimeForm.totalTime = this.examData.AnswerTime * 60 + 1;
      //赋值剩余时间
      if (this.examData.AnswerHasUseTime > 0) {
        this.lastTimeForm.lastTime =
          (this.examData.AnswerTime - this.examData.AnswerHasUseTime + 1) * 60 +
          1;
      } else {
        this.lastTimeForm.lastTime = this.lastTimeForm.totalTime;
      }
      this.timeCount();
    } else {
      this.$message.error("参数传递错误，请重新登录");
      let jumpPage = sessionStorage.getItem("indexPage");
      this.$router.push("/" + jumpPage);
    }
  },
};
</script>
<style scoped>
/* 页面特有样式，公共样式见 global.css */
</style>


// WEBPACK FOOTER //
// src/views/Test.vue